<template>
	<div v-if="settings.visible" :disabled="settings.disabled || !settings.userHasAccess ? true : null" class="d-inline-flex align-items-center">
		<div class="dropdown" v-if="!settings.selfButton">
			<button ref="dropbutton" :class="['btn btn-outline-primary btn-sm dropdown-toggle', { 'disabled': settings.disabled, 'mini': settings.mini }]" :disabled="settings.disabled" :title="settings.tooltipEnabled && settings.hideTooltip ? tooltip : ''" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<icon v-if="!settings.hideIcon && settings.icon && settings.icon != ''" :icon="settings.icon" />
				<span v-if="!settings.hideTitle && !settings.mini && settings.title != ''" class="button-title">{{ settings.title }}</span>
			</button>
			<nk-tooltip
				v-if="!settings.hideTooltip"
				:target="() => $refs.dropbutton"
				:title="settings.title"
				:shortcut="settings.shortcut"
				:hideTitle="settings.hideTitle"
				:hideTooltip="settings.hideTooltip"
				:disabled="!!settings.disabled"
			/>
			<div class="dropdown-menu dropdown-menu-right max-300">
				<template v-for="(b, i) in settings.items" :key="i">
					<div class="dropdown-divider" v-if="b.type == 'divider'"></div>
					<button v-if="b.type != 'divider'" @click.stop="(e) => click(b, e)" class="dropdown-item" type="button">
						<icon v-if="!b.hideIcon && b.icon && b.icon != ''" :icon="b.icon" />
						<span v-if="!b.hideTitle && b.title != ''" class="button-title">{{ b.title }}</span>
					</button>
				</template>
			</div>
		</div>
		<div class="btn-group d-flex" v-if="settings.selfButton">
			<button type="button" @click="hideShortcuts" class="btn dropdown-toggle-split drop-button m-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<span class="sr-only"></span>
				<icon icon="angle-down" />
			</button>
			<button ref="mainBtn" type="button" @click.stop="(e) => click(settings, e)" :disabled="settings.disabled ? true : null" :title="settings.tooltipEnabled && settings.hideTooltip ? tooltip : ''" :class="['btn btn-sm border-changed m-0', { 'btn-primary': settings.isPrimary, 'btn-warning': settings.isWarning, 'btn-danger': settings.isDanger, 'btn-outline-primary': !settings.isPrimary && !settings.isWarning && !settings.isDanger, 'disabled': settings.disabled }]">
				<icon v-if="!settings.hideIcon && settings.icon && settings.icon != ''" :icon="settings.icon" />
				<span v-if="!settings.hideTitle && settings.title != ''" class="button-title">{{ settings.title }}</span>
				<span v-if="!settings.hideShortcut && settings.shortcut.keyCode > 0" class="shortcut">{{ shortcutDisplay(settings) }}</span>
			</button>
			<nk-tooltip
				v-if="!settings.hideTooltip"
				:target="() => $refs.mainBtn"
				:title="settings.title"
				:shortcut="settings.shortcut"
				:hideTitle="settings.hideTitle"
				:hideTooltip="settings.hideTooltip"
				:disabled="!!settings.disabled"
			/>
			<div class="dropdown-menu dropdown-menu-right max-300" :set="nonDividerButtons = settings.items ? settings.items.filter(x => x.type !== 'divider') : []">
				<template v-for="(b, i) in settings.items">
					<span class="dropdown-item d-flex justify-content-between" :class="{ 'disable': b.disabled }" :key="i" v-if="b.type != 'divider'" @click.stop="(e) => { if (!b.disabled) click(b, e) }" href="#">
						<div style="display: flow">
							<icon v-if="!b.hideIcon && b.icon && b.icon != ''" :icon="b.icon" />
							<span v-if="!b.hideTitle && b.title != ''" class="button-title">{{ b.title }}</span>
							<span v-if="b.shortcut && !b.hideShortcut && b.shortcut.keyCode > 0" class=" shortcut-in-row shortcut">{{ shortcutDisplay(b) }}</span>
						</div>
						<div v-if="b.commands && b.commands.length > 0" class="text-left">
							<i v-for="command in b.commands" :key="command" :title="command.title" :class="['command', command.icon, { 'disable': command.disabled }]" @click.stop="() => { if (!command.disabled) command.handler() }"></i>
						</div>
					</span>
					<div class="dropdown-divider" :key="i" v-if="b.type == 'divider' && nonDividerButtons.length > 1"></div>
				</template>
				<div v-if="!nonDividerButtons.length" class="text-center">{{ $t('no-items-found') }}</div>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	export default {
		props: {
			options: {
				type: Object,
				required: true
			}
		},
		emits: ['click', 'optionsChanged'],
		data() {
			return {
				settings: {
					mini: false,
					isPrimary: false,
					disabled: false,
					visible: true,
					userHasAccess: null,
					icon: '',
					title: '',
					element: () => {
						return this.grandParent
					},
					hideShortcut: false,
					hideTitle: false,
					hideIcon: false,
					hideTooltip: true,
					tooltipEnabled: false,
					shortcut: {
						keyCode: 0,
						ctrlKey: false,
						shiftKey: false,
						altKey: false,
						display: ''
					},
					policyToken: null,
					items: [],
					selfButton: false
				}
			}
		},
		computed: {
			tooltip() {
				let parts = []

				if (this.settings.title && this.settings.title.length > 0) {
					parts.push(this.settings.title)
				}

				let sc = this.shortcutDisplay(this.settings)
				if (sc && sc.length > 0) {
					parts.push(`(${sc})`)
				}

				return parts.join(' ').trim()
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(value, oldValue) {
					let callSubscribeKeys = !_.isEqual(this.settings.shortcut, value.shortcut)
					// value.items && value.items.forEach(x=>{
					//   this.settings.items.push({  ...x,...this.settings.shortcut})
					// })
					this.settings = _.extend(this.settings, value)
					this.checkUserPermission()
					if (callSubscribeKeys) {
						this.subscribeKeys()
					}
				}
			}
		},
		methods: {
			click(button, e) {
				if (!this.settings.disabled) {
					$('.dropdown-menu').removeClass('show')
					this.$emit('click', button, e)
					this.hideShortcuts()
				}
			},
			shortcutDisplay(settings) {

				var arr = []
				var sc = settings.shortcut

				if (sc.keyCode > 0) {
					if (sc.ctrlKey === true) {
						arr.push('Ctrl')
					}
					if (sc.shiftKey === true) {
						arr.push('Shift')
					}
					if (sc.altKey === true) {
						arr.push('Alt')
					}

					var key = sc.keyCode
					var keyChar = String.fromKeyCode(key)
					keyChar = keyChar || ''

					arr.push(keyChar)
					return arr.join(' + ')
				} else {
					return ''
				}
			},
			checkUserPermission() {
				const checkPermission = (setting) => {

					let hasAccess = true

					if (setting.visible === false)
						hasAccess = false

					else if (setting.policyClaims != null)
						hasAccess = this.$nikan.checkPermission(setting.policyClaims)

					if (setting.userHasAccess !== hasAccess) {
						setting.userHasAccess = hasAccess
						this.$emit('optionsChanged', setting)
					}

					return hasAccess
				}

				if (checkPermission(this.settings))
					this.settings.items = this.settings.items.filter(x => checkPermission(x))
			},
			subscribeKeys() {
				if (this.settings.disabled || this.settings.shortcut.keyCode == 0) return
				this.$keyHandler.Subscribe({
					name: `${this.settings.title}-button-${this.settings.id}`,
					...this.settings.shortcut,
					el: this.settings.element(),
					context: this,
					handler: function (sender, e) {
						if (e.keyCode !== this.settings.shortcut.keyCode || this.settings.disabled)
							return

						this.click(this.settings, e)
						return true
					},
				})
				this.settings.items && this.settings.items.forEach(x => {
					this.$keyHandler.Subscribe({
						name: `${x.title}-button-${x.id}`,
						...x.shortcut,
						el: this.settings.element(),
						context: this,
						handler: (sender, e) => {
							if (e.keyCode !== x.shortcut?.keyCode || x?.disabled)
								return

							this.click(x, e)
							return true
						},
					})

				})
			},
		}
	}
</script>
